// documentAddress.js — format structured address for document letterheads

import { formatLocationPostalValue } from 'utilities/Location';

/**
 * @param {unknown} value
 * @returns {string}
 */
export function formatDocumentAddress(value) {
  if (value == null || value === '') return '';
  if (typeof value === 'string') return String(value).trim();
  if (typeof value === 'object' && !Array.isArray(value)) {
    return String(formatLocationPostalValue(value) || '').trim();
  }
  return '';
}
